
import image1 from '../images/testimonial/1.jpg';
import image2 from '../images/testimonial/2.jpg';
import image3 from '../images/testimonial/3.jpg';
import image4 from '../images/testimonial/4.jpg';
import image5 from '../images/testimonial/5.jpg';
import image6 from '../images/testimonial/6.jpg';

const TestimonialData = [
     {
        id: "01",
        text: "I’ve  witnessed the incredible care given to patients, especially children. The joy of healing is immeasurable for families and staff alike. To all medical professionals: your dedication is truly valued . Congratulations on your noble, life-changing service!",
        title: "Taye Atske Selassie",
        subtitle: "President of Ethiopia",
        image: image6
    },
    {
        id: "02",
        text: "I am deeply thankful for the work Heart to Heart Children Aid Foundation is doing. By providing life-saving surgeries and care to children in need, they are not only saving lives but also giving our nation hope. This is truly commendable and a blessing for our country.",
        title: "Mulatu Teshome Wirtu  ",
        subtitle: "Former President of Ethiopia",
        image: image4
    },
    {
        id: "03",
        text: "Caring for the welfare of these vulnerable children is, without question, caring for the future of our entire nation. We believe the truly compassionate work you are doing here is profoundly blessed by the Almighty, and it undoubtedly brings immense joy to God’s heart",
        title: "Patriarch Abune Mathias",
        subtitle: "Patriarch of the Ethiopian Orthodox Tewahedo Church",
        image: image1
    },
    {
        id: "04",
        text: "Saving a child’s life is a supremely blessed act that gladdens the very heart of God and honors the sanctity of every human life. We offer our prayers for the Heart to Heart Children’s Aid Foundation and all supporters of this life-giving mission.",
        title: "Cardinal Berhaneyesus",
        subtitle: "Metropolitan Archbishop of Addis Ababa",
        image: image5
    },
    {
        id: "05",
        text: " I always wished our vulnerable children could access life-saving medical care. Today, I am profoundly grateful to Allah to see that sacred dream come true; these free surgeries bring immense hope, ensuring a brighter, healthier future for every child ",
        title: "Sheikh Haji Ibrahim Tufa",
        subtitle: "President of the Ethiopian Islamic Affairs Supreme Council",
        image: image2
    },

    {
        id: "06",
        text: "We extend our profound and heartfelt gratitude to Heart-to-Heart Children Aid for its life-saving contribution to the critical field of cardiac surgery. Your unwavering support for our nation's most vulnerable children is truly appreciated, and deeply impacts their future.",
        title: "Dr. Endale Gebre",
        subtitle: "President of the Ethiopian Heart Association",
        image: image3
    },
      

]

export default TestimonialData;